var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIbChevronLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#ib-chevron-left_svg__filter0_d_919_74341)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 4l17.638 5.941A2 2 0 0121 11.837v15.582a2 2 0 01-1.291 1.87L2 36V4z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ib-chevron-left_svg__clip0_919_74341)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.054 26.388a.952.952 0 01-1.347 0l-5.714-5.715a.952.952 0 010-1.347l5.714-5.714a.952.952 0 011.347 1.347l-5.04 5.04 5.04 5.042a.952.952 0 010 1.347z",
    fill: "#AAA"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ib-chevron-left_svg__clip0_919_74341"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(3.333 13.333)",
    d: "M0 0h13.333v13.333H0z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "ib-chevron-left_svg__filter0_d_919_74341",
    x: 0,
    y: 0,
    width: 27,
    height: 40,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_919_74341"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_919_74341",
    result: "shape"
  })))));
}

export default SvgIbChevronLeft;